<template>
    <div>
        <h6 class="font-weight-bold my-3">Cancellation Profile</h6>
        <table class="table table-sm table-striped">
            <thead class="thead-dark">
            <tr>
                <th></th>
                <th>Cancellations</th>
                <th>Non Activated</th>
                <th>% Non Activated</th>
                <th>Inclusive</th>
                <th>Addon</th>
                <th>N/A</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>Scheme To Date</td>
                <td>{{ cancelled.all }}</td>
                <td>{{ cancelled.all_never_used }}</td>
                <td>{{ Math.round(cancelled.all_never_used/cancelled.all*100) }}%</td>
                <td>{{ cancelled.all_inclusive }}</td>
                <td>{{ cancelled.all_addon }}</td>
                <td>{{ cancelled.all_noproductid }}</td>
            </tr>
            <tr>
                <td>YTD {{ year }}</td>
                <td>{{ cancelled.ytd }}</td>
                <td>{{ cancelled.ytd_never_used }}</td>
                <td>{{ Math.round(cancelled.ytd_never_used/cancelled.ytd*100) }}%</td>
                <td>{{ cancelled.ytd_inclusive }}</td>
                <td>{{ cancelled.ytd_addon }}</td>
                <td>{{ cancelled.ytd_noproductid }}</td>
            </tr>
            <tr>
                <td>{{ monthName }} {{ year }}</td>
                <td>{{ cancelled.month }}</td>
                <td>{{ cancelled.month_never_used }}</td>
                <td>{{ Math.round(cancelled.month_never_used/cancelled.month*100) }}%</td>
                <td>{{ cancelled.month_inclusive }}</td>
                <td>{{ cancelled.month_addon }}</td>
                <td>{{ cancelled.month_noproductid }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: "ReportCancellationProfile",
        props: ['cancelled','year','monthName','report'],
    }
</script>

<style scoped>

</style>
